module.exports = {
    "dismiss": `Odbaci`
};


//# sourceMappingURL=hr-HR.main.js.map
